import { useCallback, useEffect, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getAttendanceStatistics } from "../api/attendance.api";
import type { AttendanceStatistics } from "../types/attendance.types";

export const useAttendanceStatistics = () => {
  const [data, setData] = useState<AttendanceStatistics | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { run, loading } = useLatestRequest();

  const refresh = useCallback(async () => {
    setError(null);
    try {
      const response = await run((signal) => getAttendanceStatistics(signal));
      if (response) setData(response);
    } catch (requestError: unknown) {
      setData(null);
      setError(
        requestError instanceof Error
          ? requestError.message
          : "Failed to load attendance statistics",
      );
    }
  }, [run]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { data, loading, error, refresh };
};
